import { constructorName } from './helpers';

/**
 * Determines whether the given value is a generator object.
 */
export function isGeneratorObject(value: any): boolean {
  return (
    typeof value.throw === 'function' &&
    typeof value.return === 'function' &&
    typeof value.next === 'function'
  );
}

export function isGeneratorFunction(
  value: any,
): value is GeneratorFunction {
  const name = constructorName(value);

  return name === 'GeneratorFunction' || name === 'GeneratorFunction.js';
}
